import React from 'react';
import './PaymentResultModal.scss';

const PaymentResultModal = ({ result, onClose }) => {
  if (!result) {
    return null;
  }

  return (
    <div className="payment-result-overlay" role="dialog" aria-modal="true" aria-labelledby="payment-result-title">
      <div className={`payment-result-card payment-result-card--${result.variant || 'success'}`}>
        <h3 id="payment-result-title">{result.title}</h3>
        {result.subtitle && <p className="payment-result-subtitle">{result.subtitle}</p>}
        {result.rows?.length > 0 && (
          <dl className="payment-result-details">
            {result.rows.map((row) => (
              <div key={row.label} className="payment-result-row">
                <dt>{row.label}</dt>
                <dd>{row.value}</dd>
              </div>
            ))}
          </dl>
        )}
        <button type="button" className="payment-result-close" onClick={onClose}>
          Continue
        </button>
      </div>
    </div>
  );
};

export default PaymentResultModal;
